module.exports = __webpack_public_path__ + "media/NewBJ.344e030a.mp4";